function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './SectionIntro.css';
import React, { useRef, useEffect } from 'react';
import { get, replaceWhitespace } from '../../utils';
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../atoms/RouterLink';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useHistory } from 'react-router-dom';
function handleScrollToRef(scrollElemRef, extraHeightCalculator) {
  if (!scrollElemRef.current) {
    return;
  }
  const scrollElem = scrollElemRef.current;
  if (!scrollElem) {
    return;
  }
  let mainHeight = 0;
  // NOTE: this class name is declared in the MainNavigation component.
  const mainNav = document.querySelector('.main-nav.main-nav-static');
  if (mainNav) {
    mainHeight = mainNav.clientHeight;
  }
  const extraHeight = extraHeightCalculator && mainNav ? extraHeightCalculator(mainNav) : 0;
  const combinedHeight = mainHeight + extraHeight + 10;
  const rect = scrollElem.getBoundingClientRect();
  const scrollPosition = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
  window.scrollTo(0, scrollPosition - combinedHeight);
}
export const SectionIntro = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const history = useHistory();
  const hash = history.location.hash && decodeURI(history.location.hash.split('#')[1]) || null;
  const componentRef = useRef(null);
  const extraHeightCalculator = mainNavElem => parseInt(window.getComputedStyle(mainNavElem, '::after').height || '');
  useEffect(() => {
    if (fields.data.item && fields.data.item.title.jss.value && hash && fields.data.item.title.jss.value == hash) {
      handleScrollToRef(componentRef, extraHeightCalculator);
    }
  }, [hash]);
  if (!fields || !fields.data.item) {
    console.info('SectionIntro component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SectionIntro component is empty: please provide data source]");
    }
    return null;
  }
  const titleField = get(fields, 'data.item.title.jss');
  const nameField = get(fields, 'data.item.name', '');
  const hasTitle = !!(titleField && titleField.value && titleField.value.trim());
  const hasDescription = Boolean(get(fields, 'data.item.description.jss.value')) || false;
  const hasLink = Boolean(get(fields, 'data.item.ctaLink.jss.value.href') && get(fields, 'data.item.ctaLabel.jss.value')) || false;
  const {
    learnMoreAnalytics
  } = fields.data;
  const item = fields.data.item;
  const conditionalAttrs = hasTitle ? {
    id: replaceWhitespace(fields.data.item.title.jss.value.trim())
  } : {};
  const renderLink = () => {
    if (!hasLink) return null;
    let linkAlt = '';
    linkAlt = hasTitle ? titleField.value : nameField;
    linkAlt = linkAlt ? `${linkAlt} | ${fields.data.item.ctaLabel.jss.value}` : fields.data.item.ctaLabel.jss.value;
    if (pageEditing) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
      field: fields.data.item.ctaLabel
    })), "Link: ", /*#__PURE__*/React.createElement(Link, {
      field: fields.data.item.ctaLink
    }));
    return /*#__PURE__*/React.createElement("div", null, item ? /*#__PURE__*/React.createElement(RouterLink, {
      href: fields.data.item.ctaLink.jss.value.href,
      className: "btn btn-secondary",
      title: linkAlt,
      linktype: fields.data.item.ctaLink.jss.value.linktype,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(learnMoreAnalytics, params), fields.data.item.name);
      }
    }, /*#__PURE__*/React.createElement("span", null, fields.data.item.ctaLabel.jss.value)) : null);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    pageEditing: pageEditing,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, item ? /*#__PURE__*/React.createElement("div", _extends({
    className: "section-intro",
    "data-cy": "section-intro",
    ref: componentRef
  }, conditionalAttrs), hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h3 section__title",
    tag: "h3",
    field: titleField
  }), hasDescription && /*#__PURE__*/React.createElement(RichText, {
    className: "body-small s__desc",
    tag: "div",
    field: fields.data.item.description.jss
  }), renderLink()) : null);
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    pageEditing,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${pageEditing && onPageEditor}`
  }, children);
};
const onPageEditor = "o11e36is";
const commonStyles = "cyx0dg4";
const ltrStyles = "lj5olca";
const rtlStyles = "r1hlurtl";
export default SectionIntro;